module.exports = __webpack_public_path__ + "img/image145.ddaf3b5c.jpg";